if (!customElements.get('related-articles-pagination')) {
  class RelatedArticlesPagination extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('click', this.onClick.bind(this));
    }

    onClick(event) {
      const link = event.target.closest('a[data-page]');
      if (!link || !this.contains(link)) return;

      event.preventDefault();
      this.loadPage(link.dataset.page);
    }

    async loadPage(page) {
      const url = `${window.location.pathname}?section_id=${this.dataset.sectionId}&page=${encodeURIComponent(page)}`;

      this.setAttribute('aria-busy', 'true');
      this.classList.add('is-loading');

      try {
        const response = await fetch(url);
        if (!response.ok) throw new Error(`HTTP ${response.status}`);

        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const next = html.querySelector('related-articles-pagination');
        if (!next) throw new Error('Missing related articles in response');

        this.innerHTML = next.innerHTML;

        const section = this.closest('.shopify-section') || this;
        if (section.getBoundingClientRect().top < 0) {
          section.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      } catch (error) {
        // Fall back to a full page load so the visitor still reaches the page
        window.location.href = `${window.location.pathname}?page=${encodeURIComponent(page)}#shopify-section-${this.dataset.sectionId}`;
      } finally {
        this.removeAttribute('aria-busy');
        this.classList.remove('is-loading');
      }
    }
  }

  customElements.define('related-articles-pagination', RelatedArticlesPagination);
}
